import React from "react";
import routes from "utils/absoluteRoutes";
import { useLocation } from "@reach/router";
import {
  NavWrapper,
  NavList,
  NavItem,
  IconWrapper,
  NavLink,
  BottomNavItem,
} from "./styles";
import Link from "components/link";

import { ReactComponent as SignOutIcon } from "assets/images/sign-out-icon.svg";
import { ReactComponent as GearIcon } from "assets/images/gear-menu-icon.svg";
import { ReactComponent as MyBusinessIcon } from "assets/images/my-business-icon.svg";
import { ReactComponent as MarketplaceIcon } from "assets/images/marketplace-icon.svg";
import { ReactComponent as TasksIcon } from "assets/images/tasks-icon.svg";
import { ReactComponent as SurveysIcon } from "assets/images/surveys-icon.svg";
import { ReactComponent as LearnIcon } from "assets/images/learn-icon.svg";
import { ReactComponent as MentorIcon } from "assets/images/mentor-icon.svg";

import { MenuDivider } from "components/menu/styles";
import auth from "containers/auth";

export const navItems = [
  {
    title: "My Business",
    Icon: MyBusinessIcon,
    route: routes.bizProfile,
    graphic: require("assets/images/zlto-esd-graphic-business.svg"),
  },
  {
    title: "Marketplace",
    Icon: MarketplaceIcon,
    route: routes.marketplace,
    graphic: require("assets/images/layout-graphic-two.svg"),
  },
  {
    title: "Tasks",
    Icon: TasksIcon,
    route: routes.opportunities,
  },
  {
    title: "Surveys",
    Icon: SurveysIcon,
    route: routes.surveys.view,
  },
  {
    title: "Learn",
    Icon: LearnIcon,
    route: routes.learn.view,
  },
  {
    title: "My Mentor",
    Icon: MentorIcon,
    route: routes.mentor,
  },
  {
    title: "Settings",
    Icon: GearIcon,
    route: routes.settings,
    graphic: require("assets/images/zlto-esd-graphic-business.svg"),
    visible: false,
  },
];

const Nav = () => {
  const location = useLocation().pathname;

  return (
    <NavWrapper>
      <NavList>
        {navItems.map(({ Icon, route, title, visible = true }, index) => {
          const active = location.includes(route);
          const variant = active ? "zltoDarkBlue" : "grey2";
          return (
            visible && (
              <NavItem key={index}>
                <IconWrapper active={active}>
                  <Icon />
                </IconWrapper>
                <NavLink>
                  <Link variant={variant} weight="bold" to={route}>
                    {title}
                  </Link>
                </NavLink>
              </NavItem>
            )
          );
        })}

        <BottomNavItem>
          <MenuDivider />
          <NavItem>
            <IconWrapper>
              <SignOutIcon />
            </IconWrapper>
            <NavLink variant="grey2" weight="bold" onClick={auth.logout}>
              Sign out
            </NavLink>
          </NavItem>
        </BottomNavItem>
      </NavList>
    </NavWrapper>
  );
};

export default Nav;
